(() => {
  const awayTitle = "✌️ Your coffee is waiting…";
  let lastVisibleTitle = document.title;

  const setTitle = (title) => {
    if (document.title !== title) document.title = title;
  };

  const onVisibilityChange = () => {
    if (document.hidden) {
      lastVisibleTitle = document.title; // preserve any dynamic title
      setTitle(awayTitle);
    } else {
      setTitle(lastVisibleTitle);
    }
  };

  document.addEventListener("visibilitychange", onVisibilityChange, {
    passive: true,
  });
})();
